import { fromJS, Map, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
  IChangeField,
  setInModel,
} from '../../../utils/helpers/model.helper';

export const contentFactory = (
  schema: any,
  schemaChanges: (props: Map<String, any>) => IChangeField[] = () => []
) => {
  class Content extends Record(generateSchema(schema)) {
    KEYS: any;

    constructor(props?: any) {
      props = props && props.toMap ? props.toMap() : fromJS(props || {});

      super(props);

      const selfModel = setInModel(
        this,
        schemaChanges ? schemaChanges(props) : []
      );

      this.KEYS = generateKeys(schema);

      return selfModel as Content;
    }
  }

  return Content;
};
